module.exports = __webpack_public_path__ + "img/course-classic.59f6ab4b.png";